export default "__VITE_ASSET__DL75XDKu__"